import { GetProjectEstimatesQuery } from '@/gql/graphql';

export type Contact = NonNullable<
  GetProjectEstimatesQuery['projectById']['customer']
>['contacts'][number];

export const sortContacts = (contacts: readonly Contact[]): Contact[] =>
  [...contacts].sort((a, b) => {
    if (a.isPrimary && !b.isPrimary) return -1;
    if (!a.isPrimary && b.isPrimary) return 1;
    return (a.name ?? '').localeCompare(b.name ?? '');
  });

export const resolveRecipient = (
  contacts: Contact[],
  override: Contact | null
): Contact | null => {
  const defaultRecipient =
    contacts.find((c) => c.isPrimary) ?? contacts[0] ?? null;
  return (
    (override && contacts.find((c) => c.publicId === override.publicId)) ||
    defaultRecipient
  );
};
